import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { MessageContext } from "../../../common/message";
import Tooltip from "../../../common/tooltip/Tooltip";
import CustomConfirmVoteModal from "./customModals/CustomConfirmVoteModal";

const VotingFooterButtons = ({ selectedCandidate, id, disabled, content, msgToggle }) => {
  const history = useHistory();
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const [modalActive, setModalActive] = useState(false);

  const goback = () => {
    if (!msgToggle)
      message.toggle({
        title: t("voting.votingMsg.admonishment"),
        content: t("voting.votingMsg.votingQuitclaim"),
        yesLabel: t("modalMessage.yesLabel"),
        onYes: () => {
          message.toggle({});
          history.push(`/elections`);
        },
        onNo: () => message.toggle({}),
      });
    else history.push(`/elections`);
  };

  const handleClickVote = () => {
    const arrayOfCandidates = Array.isArray(selectedCandidate);
    let isArrayOfCandidatesEmpty = true;

    if (arrayOfCandidates) {
      for (let i = 0; i < selectedCandidate.length; i++) {
        if (Object.keys(selectedCandidate[i]).length !== 0) {
          isArrayOfCandidatesEmpty = false;
        }
      }
      if (isArrayOfCandidatesEmpty) {
        message.toggle({
          title: t("voting.votingMsg.admonishment"),
          content: "Molimo odaberite kandidate.",
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      } else {
        setModalActive(true);
      }
    } else {
      // checks if var is null or undefined, ("==" is intentional)
      if (selectedCandidate == null) {
        message.toggle({
          title: t("voting.votingMsg.admonishment"),
          content: t("voting.votingMsg.selectCandidate"),
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      } else {
        setModalActive(true);
      }
    }
  };

  return (
    <>
      <CustomConfirmVoteModal
        setModalActive={setModalActive}
        active={modalActive}
        selectedCandidate={selectedCandidate}
        id={id}
      />
      <div className="is-flex is-align-items-center is-justify-content-center is-size-4">
        <button onClick={goback} className="button is-danger is-outlined ">
          Odustani
        </button>
        <Tooltip content={disabled ? content : t("voting.buttonTooltip.klickToVote")} delay={0}>
          <button
            className={true ? "button is-success is-outlined ml-4" : "button is-outlined ml-4"}
            onClick={handleClickVote}
            disabled={disabled}
          >
            Glasaj
          </button>
        </Tooltip>
      </div>
    </>
  );
};

export default VotingFooterButtons;
